import * as routes from './logoBuilderRoutes';
import joinUrl from 'url-join';
import queryString from 'query-string';
import { stateToUrlParams } from './logoStateHelpers';
export var LogoUrlGenerator = /*#__PURE__*/function () {
  function LogoUrlGenerator(_ref) {
    var protocol = _ref.protocol,
        host = _ref.host,
        mountPoint = _ref.mountPoint,
        debugApp = _ref.debugApp,
        _ref$isMobile = _ref.isMobile,
        isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
    this.protocol = protocol;
    this.host = host;
    this.mountPoint = mountPoint;
    this.debugApp = debugApp;
    this.isMobile = isMobile;
  }

  var _proto = LogoUrlGenerator.prototype;

  _proto._createParam = function _createParam(name, value) {
    return name + "=" + encodeURIComponent(value);
  };

  _proto._createSearchParams = function _createSearchParams(arrKeyValuePairs) {
    var _this = this;

    if (arrKeyValuePairs === void 0) {
      arrKeyValuePairs = [];
    }

    var searchParams = [];
    arrKeyValuePairs.forEach(function (keyValue) {
      var key = keyValue.key,
          value = keyValue.value;
      searchParams.push(_this._createParam(key, value));
    });

    if (this.debugApp) {
      searchParams.push(this._createParam('debugApp', this.debugApp));
    }

    return searchParams.length ? "?" + searchParams.join('&') : '';
  };

  _proto._getBaseMount = function _getBaseMount() {
    return this.protocol + "//" + this.host + this.mountPoint;
  };

  _proto.createUrl = function createUrl(path, params, options) {
    if (params === void 0) {
      params = {};
    }

    if (options === void 0) {
      options = {};
    }

    var isRelative = !!options.isRelative;
    var basePath = '/';

    if (!isRelative) {
      basePath = this._getBaseMount();
    }

    var paramsString = queryString.stringify(params);

    if (paramsString.length) {
      paramsString = '?' + paramsString;
    }

    return joinUrl(basePath, path, paramsString);
  };

  _proto.getHomePageUrl = function getHomePageUrl(arrKeyValuePairs) {
    if (arrKeyValuePairs === void 0) {
      arrKeyValuePairs = [];
    }

    return this._getBaseMount() + this._createSearchParams(arrKeyValuePairs);
  };

  _proto.getIndustryOnboardingUrl = function getIndustryOnboardingUrl(arrKeyValuePairs) {
    if (arrKeyValuePairs === void 0) {
      arrKeyValuePairs = [];
    }

    var searchParams = this._createSearchParams(arrKeyValuePairs);

    return joinUrl(this._getBaseMount(), routes.INDUSTRY, searchParams);
  };

  _proto.getBrandStudioUrl = function getBrandStudioUrl(logoId, origin) {
    return "" + this._getBaseMount() + routes.DASHBOARD_BRAND_STUDIO + "?logoId=" + logoId + (origin ? "&referralAdditionalInfo=" + origin : '');
  };

  _proto.getThankyouPageUrl = function getThankyouPageUrl(purchaseId, previewUrl, planId, logoId, objOptionalParams) {
    if (objOptionalParams === void 0) {
      objOptionalParams = {};
    }

    if (!purchaseId || !planId) {
      throw new Error('Missing params for creating thankyou url');
    }

    var _objOptionalParams = objOptionalParams,
        _objOptionalParams$pa = _objOptionalParams.path,
        path = _objOptionalParams$pa === void 0 ? '' : _objOptionalParams$pa,
        _objOptionalParams$ex = _objOptionalParams.extraUrlParams,
        extraUrlParams = _objOptionalParams$ex === void 0 ? '' : _objOptionalParams$ex,
        _objOptionalParams$is = _objOptionalParams.isEditedLogo,
        isEditedLogo = _objOptionalParams$is === void 0 ? false : _objOptionalParams$is;
    var logoIdParams = '';
    var isEditedParam = '';

    if (logoId) {
      logoIdParams = "&logoId=" + logoId;
    }

    if (isEditedLogo) {
      isEditedParam = "&isEditedLogo=true";
    }

    var returnUrlParams = "packageUniqueId=" + purchaseId + "&previewUrl=" + encodeURIComponent(previewUrl) + "&planId=" + planId + logoIdParams + isEditedParam;
    return this.protocol + "//" + this.host + this.mountPoint + routes.THANK_YOU + path + "?" + returnUrlParams + extraUrlParams;
  };

  _proto.getPrintThankyouUrl = function getPrintThankyouUrl() {
    return "" + this._getBaseMount() + routes.PRINTS_THANKYOU;
  };

  _proto.getPrintProductsUrl = function getPrintProductsUrl() {
    return "" + this._getBaseMount() + routes.PRINTS_PRODUCTS;
  };

  _proto.getPrintCheckoutUrl = function getPrintCheckoutUrl() {
    return "" + this._getBaseMount() + routes.PRINTS_CHECKOUT;
  };

  _proto.getLogoPrintUrl2 = function getLogoPrintUrl2(logoId, referralAdditionalInfo, editType, options) {
    if (editType === void 0) {
      editType = '';
    }

    var printSuffix = options.printSuffix,
        printStaging = options.printStaging;
    var debugApp = this.debugApp;
    var params = {
      logoId: logoId,
      printSuffix: printSuffix,
      debugApp: debugApp
    };

    if (printStaging && this.debugApp && this.debugApp.indexOf('printStaging') === -1) {
      params.debugApp = this.debugApp.replace('mockPurchase', 'printStaging|mockPurchase');
    }

    if (referralAdditionalInfo) {
      params.referralAdditionalInfo = referralAdditionalInfo;
    }

    return this.createUrl(joinUrl(routes.PRINTS_EDITOR, editType), params, options);
  };

  _proto.getLogoEditorUrl = function getLogoEditorUrl(selectedZoeTemplate, companyDetails, referral) {
    var urlParams = stateToUrlParams({
      selectedZoeTemplate: selectedZoeTemplate,
      companyDetails: companyDetails
    }, this.debugApp, referral);
    return joinUrl(this._getBaseMount(), routes.EDIT_LOGO, urlParams);
  };

  _proto.getLogoOnboardingUrl = function getLogoOnboardingUrl(companyDetails, industry, tags, referral) {
    var urlParams = stateToUrlParams({
      companyDetails: companyDetails,
      industry: industry,
      tags: tags
    }, this.debugApp, referral);
    return joinUrl(this._getBaseMount(), routes.COMPANY_DETAILS, urlParams);
  };

  _proto.getPremiumDomainsUrl = function getPremiumDomainsUrl(domainName, referral) {
    if (domainName === void 0) {
      domainName = '';
    }

    if (referral === void 0) {
      referral = '';
    }

    return "https://apps.wix.com/redirect-post-domain/?domainName=" + domainName.trim() + "&referralAdditionalInfo=" + referral;
  };

  _proto.getNewWebsiteUrl = function getNewWebsiteUrl(referral) {
    var redirectUrl = this.isMobile ? "https://www.wix.com/website/builder#!/intro/start" : "https://www.wix.com/new/vertical"; // eslint-disable-next-line camelcase

    var query = queryString.stringify({
      additional_referral_info: referral
    });
    return redirectUrl + "?" + query;
  };

  _proto.getLogoShareUrl = function getLogoShareUrl(userId, logoKey) {
    return this.createUrl(joinUrl(routes.SHARE, userId, logoKey + ''), {}, {});
  };

  return LogoUrlGenerator;
}();